function initClickAttribute() {
  if (document.querySelector('.Tabs__block-grid') != null) {
    try {
      const elements = document.querySelector('.Tabs__block-grid')
      const btnSecond = document.querySelector('.section-directory__tab[data-grid="second"]')
      const btnMain = document.querySelector('.section-directory__tab[data-grid="main"]')
  
      btnSecond.addEventListener('click', () => {
        elements.classList.add('grid--second')
        elements.classList.remove('grid--main')
      })
      btnMain.addEventListener('click', () => {
        // elements.classList.add('grid--main')
        elements.classList.remove('grid--second')
      })
    } catch {
      console.log('Ошибка initClickAttribute')
    }
  }
}
